export default __webpack_public_path__ + "static/media/March2012.3b1eec3a.png";